import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import type {
  DemandSummaryOption,
  DemandSummaryResponse,
} from "./reports-demand-summary";

export type AttorneySummaryFilters = {
  asOfDate: string;
  period: "month-to-date" | "prior-month" | "week-to-date" | "prior-week";
  litigation: "all" | "litigation" | "non-litigation";
  roleId?: string;
};
export type AttorneySummaryGroup = {
  userId: string | null;
  label: string;
  openMatters: number;
  demandsSent: number;
  acceptedRecords: number;
  acceptedAmount: string | null;
  expectedFees: string | null;
  trustDeposits: string;
  trustWithdrawals: string;
  averageLitigationExpectedFees: string | null;
  averageNonLitigationExpectedFees: string | null;
  closedWithLinkedDeposit: number;
  averageDaysToCloseWithDeposit: string | null;
  closedWithoutLinkedDeposit: number;
  averageDaysToCloseWithoutDeposit: string | null;
};
export type AttorneySummaryResponse = {
  data: {
    groups: AttorneySummaryGroup[];
    totals: AttorneySummaryGroup;
    roles: DemandSummaryOption[];
    pinnedRoleId?: string | null;
    selectedRoleId?: string | null;
    firmDateModified?: string | null;
    canManagePinnedRole?: boolean;
    freshness: DemandSummaryResponse["data"]["freshness"];
  };
};
export async function retrieveAttorneySummary(
  filters: AttorneySummaryFilters,
  signal?: AbortSignal,
) {
  const response =
    await authenticatedFastApiAxiosInstance.post<AttorneySummaryResponse>(
      "reports/v2/attorney-summary/query",
      filters,
      { signal },
    );
  return response.data;
}

export type AttorneyReportDefaultRoleInput = {
  roleId: string | null;
  expectedPinnedRoleId: string | null;
  firmDateModified: string | null;
};
export async function updateAttorneyReportDefaultRole(
  input: AttorneyReportDefaultRoleInput,
) {
  const response = await authenticatedFastApiAxiosInstance.patch<{
    data: { pinnedRoleId: string | null; firmDateModified: string | null };
  }>("reports/v2/attorney-summary/default-role", input);
  return response.data;
}
